'use strict';

import {SectionCtrl} from "./sectionctrl.js";
import {wpModel} from "../../models/wpmodel.js";
import {participantModel} from "../../models/participantmodel.js";
import {wpActivityModel} from '../../models/wpactivitymodel.js';
import {wpDeliverableModel} from '../../models/wpdeliverablemodel.js';
import "./preview_section_a41.js";

export class SectionA41WorkActivitiesCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'a4_1_work_activities_before',
			on: false,
			value: null
		},
		after: {
			key: 'a4_1_work_activities_after',
			on: false,
			value: null
		}
	};

	workpackages = [];
	isSaved = true;
	$mdDialog;

	constructor($scope, $filter, jsDataService, $mdDialog){
		super($scope, $filter, jsDataService);
		this.$mdDialog = $mdDialog;
		if(typeof(this.section.wp) !== 'undefined'){
			this.initWP(this.section.wp);
		}
	}

	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}

	initWP(workpackages){
		this.workpackages = [];
		for(let wp of workpackages){
			this.workpackages.push(new wpModel(wp, this.$filter, this.jsDataService));
			if(typeof(wp.activities) !== 'undefined'){
				for(let activ in wp.activities){
					wp.activities[activ] = new wpActivityModel(wp.activities[activ], this.$filter, this.jsDataService);
					wp.activities[activ].application_wp_id = wp.id;
				}
			}
			if(typeof(wp.deliverables) !== 'undefined'){
				for(let dlvr in wp.deliverables){
					wp.deliverables[dlvr] = (new wpDeliverableModel(wp.deliverables[dlvr], this.$filter, this.jsDataService));
					wp.deliverables[dlvr].application_wp_id = wp.id;
				}
			}
		}
//		console.log(this.workpackages)
	}

	wpPreview(e, item){
		let fields = [];
//		if(typeof(this.section.fields)){
//			fields = this.section.fields;
//		}
		this.$mdDialog.show({
			controller: "A41PreviewCtrl",
			controllerAs: "dctrl",
			templateUrl: 'esfasi/preview_section_a41.html',
			parent: angular.element(document.body),
			targetEvent: e,
			clickOutsideToClose:true,
			fullscreen: true,
			multiple: true,
			locals: {
				item: item,
				options: {
					fields: fields,
					title: item.getValue('a4_1_work_activities_no'),
					$filter: this.$filter,
					jsDataService: this.jsDataService,
					participantField: (id, field) => {
						return this.getParticipantField(id, field);
					}
				}
			}
		})
		.then(function(result) {

		}, function () {

		});
	}

	getParticipant(id){
		if(typeof(this.section.participants) === 'undefined'){
			return null;
		}
		let prtcps = this.$filter('filter')(this.section.participants, {id: id}, true);
		if(prtcps.length < 1){
			return null;
		}
		return new participantModel(prtcps[0], this.$filter, this.jsDataService);
	}

	getParticipantField(id, field){
		if(id && typeof(id) === 'object'){
			let fields = [];
			for(let oneId of Object.values(id)){
				let participant = this.getParticipant(oneId);
				if(!participant){
					continue;
				}
				fields.push(participant.getValue(field));
			}
			if(fields.length > 0){
				return fields.join(', ');
			}
			return '';
		}
		else{
			let participant = this.getParticipant(id);
			if(!participant){
				return '';
			}
			return participant.getValue(field);
		}
	}

	loadData(){
			const url = this.jsDataService.get('cfgDataUrl');
			if(url){
				this.promise = this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'GET',
					params: {}
				}).then((response) => {
					if(response.data.success){
						this.setData(response.data.data);
					}
				}, () => {});
			}
	}

	setData(data){
		this.workpackages = [];
		for(let wp of data){
			this.workpackages.push(new wpModel(wp, this.$filter, this.jsDataService));
			if(typeof(wp.activities) !== 'undefined'){
				for(let activ in wp.activities){
					wp.activities[activ] = new wpActivityModel(wp.activities[activ], this.$filter, this.jsDataService);
					wp.activities[activ].application_wp_id = wp.id;
				}
			}

			if(typeof(wp.deliverables) !== 'undefined'){
				for(let dlvr in wp.deliverables){
					wp.deliverables[dlvr] = (new wpDeliverableModel(wp.deliverables[dlvr], this.$filter, this.jsDataService));
					wp.deliverables[dlvr].application_wp_id = wp.id;
				}
			}
		}
	}

	removeWp(ev, wp){
		if(this.jsDataService.get('cfgWpRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgWpRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: wp.id
					}
				}).then((results) => {
					if(results.data.success){
						this.loadData();
					}
				});
			}, () => {});
		}
	}

	editWp(ev, wp){
		this.wpEditor(ev, wp);
	}

	addWp(ev){
		this.wpEditor(ev, new wpModel({id: 0}, this.$filter, this.jsDataService));
	}

	wpEditor(ev, wp){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "wp", "fieldCfg", this.wpEditorDialogCtrl],
			templateUrl: 'application/wp_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				wp: wp,
				fieldCfg: this.fieldCfg
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(this.jsDataService.get('cfgWpSaveUrl')){
				this.isSaved = false;
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgWpSaveUrl'),
					method: 'POST',
					data: {
						wp: results
					}
				}).then((response) => {

					if(response.data.success){
						this.loadData();
					}
					this.isSaved = true;

				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgSaveUrl'));
			}
		}, () => {});
	}

	wpEditorDialogCtrl($scope, $mdDialog, $filter, $http, jsDataService, wp, fieldCfg){
		$scope.wp = angular.copy(wp);
		$scope.classif = angular.copy(jsDataService.get('cfgClassif', {}));
		$scope.leadBeneficiaryList = angular.copy(jsDataService.get('leadBeneficiaryList', {}));
		$scope.fieldCfg = fieldCfg;
		$scope.isField = function (name){
			return (typeof(fieldCfg[name]) !== 'undefined');
		};

		$scope.fieldRequire = function(name){
			if(!$scope.isField(name)){
				return false;
			}
			return fieldCfg[name].mandatory;
		};
		$scope.getFieldTitle = function(name){
			if(!$scope.isField(name)){
				return '';
			}
			return fieldCfg[name].title;
		};
		$scope.getFieldLimit = function(name){
			if(!$scope.isField(name)){
				return null;
			}
			if(!fieldCfg[name].limitOn){
				return null;
			}
			return fieldCfg[name].limit;
		};

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){

			$mdDialog.hide({
				id: $scope.wp.id,
				a4_1_work_activities_name: $scope.wp.a4_1_work_activities_name,
				a4_1_work_activities_objectives: $scope.wp.a4_1_work_activities_objectives,
				a4_1_work_activities_lead: $scope.wp.a4_1_work_activities_lead
			});

		};

	}

	removeWpActivity(ev, wpActiv){
//		console.log(wpActiv)
		if(this.jsDataService.get('cfgWpActivityRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				const params = {
					wp_id: wpActiv.application_wp_id,
					id: wpActiv.id
				};
				if (wpActiv.new !== undefined) {
					params.newlyadded = wpActiv.new;
				}
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgWpActivityRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: params
				}).then((results) => {
					if(results.data.success){
						this.loadData();
					}
				});
			}, () => {});
		}
	}

	editWpActivity(ev, wp, wpActiv){
		wpActiv.wp_number = wp.number;
		wpActiv.application_wp_id = wp.id;
		this.wpActivityEditor(ev, wpActiv);
	}

	addWpActivity(ev, wp){
		this.wpActivityEditor(ev, new wpActivityModel({id: 0, application_wp_id: wp.id, wp_number: wp.number}, this.$filter, this.jsDataService));
	}

	wpActivityEditor(ev, wpActiv){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "wpActiv", "fieldCfg", this.wpActivityEditorDialogCtrl],
			templateUrl: 'application/wp_activity_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				wpActiv: wpActiv,
				fieldCfg: this.fieldCfg
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(this.jsDataService.get('cfgWpActivitySaveUrl')){
				this.isSaved = false;
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgWpActivitySaveUrl'),
					method: 'POST',
					data: {
						activ: results
					}
				}).then((response) => {

					if(response.data.success){
						this.loadData();
					}
					this.isSaved = true;

				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgWpActivitySaveUrl'));
			}
		}, () => {});
	}

	wpActivityEditorDialogCtrl($scope, $mdDialog, $filter, $http, jsDataService, wpActiv, fieldCfg){
		$scope.wpActiv = angular.copy(wpActiv);
		$scope.classif = angular.copy(jsDataService.get('cfgClassif', {}));
		$scope.leadParticipants = angular.copy(jsDataService.get('participantsList', {}));
		$scope.otherParticipants = angular.copy(jsDataService.get('participantsList', {}));

		$scope.fieldCfg = fieldCfg;

		$scope.isField = function (name){
			return (typeof(fieldCfg[name]) !== 'undefined');
		};
		$scope.fieldRequire = function(name){
			if(!$scope.isField(name)){
				return false;
			}
			return fieldCfg[name].mandatory;
		};
		$scope.getFieldTitle = function(name){
			if(!$scope.isField(name)){
				return '';
			}
			return fieldCfg[name].title;
		};
		$scope.getFieldLimit = function(name){
			if(!$scope.isField(name)){
				return null;
			}
			if(!fieldCfg[name].limitOn){
				return null;
			}
			return fieldCfg[name].limit;
		};

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$scope.wpActiv.other_participants_ids = [];
			for(let parid of $scope.wpActiv.other_participants){
				$scope.wpActiv.other_participants_ids.push(parid.id);
			}
			$mdDialog.hide($scope.wpActiv.getData());

		};

		$scope.loadOtherParticipants = function(){
			$scope.wpActiv.other_participants = [];
			if(typeof($scope.wpActiv.other_participants_ids) !== 'undefined' && Object.values($scope.wpActiv.other_participants_ids).length > 0){

				for(let lsid of Object.values($scope.wpActiv.other_participants_ids)){
					let r = $filter('filter')($scope.otherParticipants, {id: lsid}, true);

					if(r.length > 0){
						$scope.wpActiv.other_participants.push(r[0]);
					}
				}
			}
		};
		$scope.loadOtherParticipants();

	}

	removeWpDeliv(ev, wpDeliv){
		if(this.jsDataService.get('cfgWpDeliverableRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				const params = {
					wp_id: wpDeliv.application_wp_id,
					id: wpDeliv.id
				};
				if (wpDeliv.new !== undefined) {
					params.newlyadded = wpDeliv.new;
				}
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgWpDeliverableRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: params
				}).then((results) => {
					if(results.data.success){
						this.loadData();
					}
				});
			}, () => {});
		}
	}

	editWpDeliv(ev, wp, wpDeliv){
		wpDeliv.wp_number = wp.number;
		wpDeliv.application_wp_id = wp.id;
		this.wpDelivEditor(ev, wpDeliv);
	}

	addWpDeliv(ev, wp){
		this.wpDelivEditor(ev, new wpDeliverableModel({id: 0, application_wp_id: wp.id, wp_number: wp.number}, this.$filter, this.jsDataService));
	}

	wpDelivEditor(ev, wpDeliv){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "wpDeliv", "fieldCfg", this.wpDelivEditorDialogCtrl],
			templateUrl: 'application/wp_deliverable_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				wpDeliv: wpDeliv,
				fieldCfg: this.fieldCfg
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(this.jsDataService.get('cfgWpDeliverableSaveUrl')){
				this.isSaved = false;
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgWpDeliverableSaveUrl'),
					method: 'POST',
					data: {
						deliv: results
					}
				}).then((response) => {

					if(response.data.success){
						this.loadData();
					}
					this.isSaved = true;

				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgWpDeliverableSaveUrl'));
			}
		}, () => {});
	}

	wpDelivEditorDialogCtrl($scope, $mdDialog, $filter, $http, jsDataService, wpDeliv, fieldCfg){
		$scope.wpDeliv = angular.copy(wpDeliv);
		$scope.classif = angular.copy(jsDataService.get('cfgClassif', {}));
//		classif.deliverablestype
//
		$scope.classif.deliverablestype.push({
			id: 'oth',
			active: '1',
			title: $filter('tr')('other')
		});

		$scope.fieldCfg = fieldCfg;

		$scope.isField = function (name){
			return (typeof(fieldCfg[name]) !== 'undefined');
		};
		$scope.fieldRequire = function(name){
			if(!$scope.isField(name)){
				return false;
			}
			return fieldCfg[name].mandatory;
		};
		$scope.getFieldTitle = function(name){
			if(!$scope.isField(name)){
				return '';
			}
			return fieldCfg[name].title;
		};
		$scope.getFieldLimit = function(name){
			if(!$scope.isField(name)){
				return null;
			}
			if(!fieldCfg[name].limitOn){
				return null;
			}
			return fieldCfg[name].limit;
		};

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide($scope.wpDeliv.getData());

		};

		$scope.getClassif = function(name){
			if(typeof($scope.classif[name]) === 'undefined'){
				return [];
			}
			if(typeof($scope.classif[name][0].active) === 'undefined'){
				return $scope.classif[name];
			}
			return $filter('filter')($scope.classif[name], {active: 1});
		};

		$scope.delivTypeChange = function(){
			if($scope.classif.deliverablestype.length > 0){
				if($scope.wpDeliv.a4_1_work_activities_deliv_type_id === 'oth'){
					$scope.delivTypeOther(true);
				}
				else{
					$scope.delivTypeOther(false);
				}
			}
			else{
				$scope.delivTypeOther(false);
			}
		};
//
		$scope.delivTypeOther = function(on){
			$scope.wpDeliv.a4_1_work_activities_deliv_type_other = !!on;
			if($scope.wpDeliv.a4_1_work_activities_deliv_type_other){
				if(arguments[1]){
					$scope.wpDeliv.a4_1_work_activities_deliv_type_other = arguments[1];
				}
			}
			else{
				$scope.wpDeliv.a4_1_work_activities_deliv_type_other_value = '';
			}
		};

		$scope.loadDelivType = function(){
			if(typeof($scope.wpDeliv.a4_1_work_activities_deliv_type_other) !== 'undefined' && ($scope.wpDeliv.a4_1_work_activities_deliv_type_other > 0 || true === $scope.wpDeliv.a4_1_work_activities_deliv_type_other)){
				$scope.wpDeliv.a4_1_work_activities_deliv_type_id = 'oth';
			}
		};
		$scope.loadDelivType();
	}
}

